<template lang="pug">
v-app.page-auth
  .background

  v-content
    v-container(fluid, fill-height)
      v-layout(column, align-start, justify-center).flex-align-center-phablet
        img.logo(src='/images/dfs-logo.svg')

        div(style='width: 350px;')
          router-view
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "@/styles/variables.scss";
@import "@/styles/responsive.scss";

$background-size: 60vw;

.page-auth {
  .v-card {
    border-radius: $border-radius;
  }

  .background {
    background-image: url("/images/login-background.jpg");
    background-position: center;
    background-size: cover;
    position: relative;
    width: $background-size;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;

    @include phablet {
      width: 100vw;
    }
  }

  .v-content {
    width: 100vw - $background-size;
    position: absolute;
    right: 0;
    top: 0;
    justify-content: flex-start;

    @include phablet {
      width: 100%;
      justify-content: center;
    }

    .v-content__wrap {
      height: 100vh;
      max-width: 700px;
    }

    .logo {
      height: 80px;
      position: absolute;
      top: 100px;
      left: 40px;

      @include phablet {
        position: initial;
        margin-bottom: $g;
      }
    }
  }

  .v-toolbar__content {
    background: white;
  }
}
</style>
